// styles

import TextField from "@mui/material/TextField";
// material ui componetns
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// packages
import classnames from "classnames";
import { ar } from "date-fns/locale";
import React, { InputHTMLAttributes, useRef } from "react";

import styles from "./styles.module.scss";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  handleChange: (value: any) => void;
  maxDate?: Date;
  minDate?: Date;
  disabled?: boolean;
}

const DatePicker: React.FC<Props> = ({
  handleChange,
  maxDate,
  minDate,
  disabled = false,
  ...props
}: Props) => {
  const inputRef = useRef<HTMLInputElement | null>(null);

  return (
    <div className={classnames(styles.container)}>
      <LocalizationProvider
        dir="rtl"
        adapterLocale={ar}
        dateAdapter={AdapterDateFns}>
        {!props.value && (
          <label className={classnames(styles.placeholder, "hint", "g600")}>
            {props.placeholder}
          </label>
        )}
        <DesktopDatePicker
          className={classnames(styles.datePicker)}
          ref={inputRef}
          label={" "}
          toolbarPlaceholder={""}
          inputFormat="yyyy/MM/dd"
          value={props.value}
          onChange={(date) => {
            handleChange(date);
          }}
          renderInput={(params) => (
            <TextField
              className={classnames(styles.text_input, "hint", "g600")}
              {...params}
            />
          )}
          maxDate={maxDate ? maxDate : null}
          minDate={minDate ? minDate : null}
          disabled={disabled}
        />
      </LocalizationProvider>
    </div>
  );
};

export default React.memo(DatePicker);
